import { DataBean } from "../../DataBean";


export class IBCCatalog extends DataBean {

    public async getPayrollIBCCatalogByEmployee(accountID: any, year: any, month: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getPayrollIBCCatalogByEmployee_Number_Number_Number", [accountID, year, month]);
    }
    public async addPayrollIBCBool( year: any, month: any,accountID: any,ibcValue:any,idEmployee:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "boolean_addPayrollIBC_Number_Number_Number_Number_Number", [ year, month,accountID,ibcValue,idEmployee]);
    }
     public async addPayrollIBC( year: any, month: any,accountID: any,welfareType:any,ibcValue:any,idEmployee:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.employees.PayrollIBC_addPayrollIBC_Number_Number_Number_Number_Number_Number", [ year, month,accountID,welfareType,ibcValue,idEmployee]);
    }
     

}